import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import * as React from 'react';

const SvgPebbleWarning = ({
  accessibilityText,
  forwardedRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  width: 24,
  height: 24,
  "aria-hidden": accessibilityText ? undefined : true,
  "aria-label": accessibilityText,
  focusable: false,
  ref: forwardedRef,
  role: accessibilityText ? 'img' : undefined
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M22.89 20 12.45 2.25A.57.57 0 0 0 12 2a.5.5 0 0 0-.45.25L1.1 20a.81.81 0 0 0-.1.36.69.69 0 0 0 .69.67H22.3a.69.69 0 0 0 .7-.68.66.66 0 0 0-.11-.35zM13 19h-2v-2h2zm0-4h-2V8h2z"
}));

export default SvgPebbleWarning;